import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { hayagrivaAppHeaders } from '../../environments/environment';

/**
 * Header Utility Service
 * 
 * Provides consistent HTTP headers across the application
 * Gets header values from environment configuration
 */
@Injectable({
  providedIn: 'root'
})
export class HeaderUtilityService {

  /**
   * Create standard API headers for hayagriva endpoints
   * @param contentType - Optional content type (defaults to 'application/json')
   * @returns HttpHeaders with authentication and tenant information
   */
  createApiHeaders(contentType: string = 'application/json'): HttpHeaders {
    const headers = new HttpHeaders({
      'Content-Type': contentType,
      'tenantuuid': hayagrivaAppHeaders.tenantuuid,
      'appuuid': hayagrivaAppHeaders.appid,
      'authorization': `Bearer ${hayagrivaAppHeaders.userToken}`
    });
    return headers;
  }

  /**
   * Create headers for document/file requests
   * @returns HttpHeaders with authentication for document endpoints
   */
  createDocumentHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      'authorization': `Bearer ${hayagrivaAppHeaders.userToken}`,
      'appuuid': hayagrivaAppHeaders.appid,
      'tenantuuid': hayagrivaAppHeaders.tenantuuid
    });
    return headers;
  }

  /**
   * Create headers for file upload requests
   * @returns HttpHeaders with authentication for upload endpoints
   */
  createUploadHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      'authorization': `Bearer ${hayagrivaAppHeaders.userToken}`,
      'tenantuuid': hayagrivaAppHeaders.tenantuuid,
      'appuuid': hayagrivaAppHeaders.appid
    });
    
    return headers;
  }

  /**
   * Get raw header values from environment
   * @returns Object with header values
   */
  getHeaderValues(): {
    tenantuuid: string;
    appid: string;
    userToken: string;
  } {
    return {
      tenantuuid: hayagrivaAppHeaders.tenantuuid,
      appid: hayagrivaAppHeaders.appid,
      userToken: hayagrivaAppHeaders.userToken
    };
  }

  /**
   * Log current header configuration for debugging
   */
  logHeaderConfig(): void {
    // Debug logging removed for production
  }
}